:host {
  display: flex;
  align-items: center;
}

.seperator {
  width: 1px;
  height: 24px;
  background: linear-gradient(to bottom, transparent, #ffffff, transparent);
}
